import RolesChecker from "features/customer/components/RolesChecker";
import { openRequirementResultDialog } from "features/requirements/helpers/requirementResultDialogHelper";
import IRequirementCreateService from "features/requirements/services/IRequirementCreateService";
import PageCard from "features/shared/components/card/PageCard";
import DynamicForm from "features/shared/forms/dynamicForm/DynamicForm";
import FormFieldDescriptor from "features/shared/forms/dynamicForm/models/FormFieldDescriptor";
import { useForm } from "features/shared/forms/hooks/useForm";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  requirementType: string;
  title: string;
  formJson: string;
};

const DynamicRequirementFormSection = ({
  requirementType,
  title,
  formJson,
}: Props) => {
  //#region translation
  const tLabels = useTranslation("requirements\\requirements").t;
  const tFormLabels = useTranslation("shared\\dynamicForms").t;
  //#endregion translation

  //#region DI
  const createService = useInjection<IRequirementCreateService>(
    IocTypes.RequirementCreateService
  );
  //#endregion DI

  //#region form hook
  const formHandler = useForm({});
  // destruct to variables
  const { values, valideteForm } = { ...formHandler };
  //#endregion form hook

  //#region handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let formDescriptors = JSON.parse(formJson) as FormFieldDescriptor[];
      let result = await createService.createDynamicRequirement(
        requirementType,
        values,
        formDescriptors,
        tFormLabels
      );


      openRequirementResultDialog(
        false,
        {
          response: result,
          successMessage: tLabels(
            "dynamicRequirementFormSection.requirementSuccessMessage"
          ),
          errorMessage: tLabels(
            "dynamicRequirementFormSection.requirementErrorMessage"
          ),
        },
        undefined,
        true
      );
    }
  };
  //#endregion handlers

  //#region render
  return (
    <form onSubmit={submitFormHandler}>
      <PageCard title={title} bodyClassName="pt-4 px-4">
        <div className="row no-gutters mx-n2">
          <DynamicForm
            formJson={formJson}
            fieldProps={{ formHandler: formHandler }}
          />
        </div>
      </PageCard>
      <RolesChecker enabledRoles="Contributor">
        <button type="submit" className="btn btn-primary px-3 py-2">
          {tLabels("dynamicRequirementFormSection.sendRequirement")}
        </button>
      </RolesChecker>
    </form>
  );
  //#endregion render
};

export default DynamicRequirementFormSection;
